import * as Sentry from '@sentry/react';
import {
  CLUSTER_NAMESPACE,
  COMSDOMAIN,
  PLATFORM_VERSION,
  SENTRY_DSN,
} from './environment';

const release =
  CLUSTER_NAMESPACE && PLATFORM_VERSION?.indexOf('release/v') > -1
    ? PLATFORM_VERSION
    : undefined;

/**
 * This is the entry point for Sentry instrumentation. The Sentry dsn needs to
 * be set on deployed environments. There is no dsn set for local development,
 * however every developer has access to Sentry and could create a local
 * project.
 *
 * The environment is set to local unless kubernetes reports a cluster
 * namespace. The release should only set in staging+. A lot more goes into
 * reporting on a release, but checking the branchname here is a good start.
 *
 * The settings in here are essentially maxed out. We are capturing everything
 * we can. Tweaks will be made in future tickets.
 */
Sentry.init({
  dsn: SENTRY_DSN,
  environment: CLUSTER_NAMESPACE ?? 'local',
  release: release,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'error', 'warn'] }),
  ],

  // Session Replay
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  _experiments: { enableLogs: true },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // enables distributed tracing, but can have some CORS issues if the backend
  // isn't configured to send the correct headers.
  tracePropagationTargets: ['localhost', COMSDOMAIN],
});

export default Sentry;
